var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .rose-cls-1 {\n        fill: #d0d6dc;\n      }\n\n      .rose-cls-2 {\n        fill: none;\n        opacity: .2;\n      }\n\n      .rose-cls-3 {\n        fill: #c2c8cc;\n      }\n\n      .rose-cls-4 {\n        fill: #b0b7bf;\n      }\n\n      .rose-cls-5 {\n        fill: #b7bfc4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2-2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "rose-cls-2",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill-2",
    className: "rose-cls-1",
    d: "M22.2,12.8c0-6.52-5.29-11.8-11.8-11.8v11.8h11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    className: "rose-cls-3",
    d: "M10.39,23c5.63,0,10.2-4.56,10.2-10.2h-10.2v10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    className: "rose-cls-5",
    d: "M1.8,12.8c0,4.74,3.84,8.59,8.59,8.59v-8.59s-8.59,0-8.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "rose-cls-4",
    d: "M10.39,5.83c-3.85,0-6.98,3.12-6.98,6.98h6.98s0-6.98,0-6.98Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRose);
export default __webpack_public_path__ + "static/media/rose.e4aa4e3c07205c5254cc065ee9063c2c.svg";
export { ForwardRef as ReactComponent };